/** Мапперы ответов «Системы» (JobRunOut, TelemetryRowOut) → домен */

import type {JobRun, JobRunStatus, TelemetryRow} from './types';

type Raw = Record<string, unknown>;
export const asObj = (v: unknown): Raw => (typeof v === 'object' && v !== null ? (v as Raw) : {});
export const asNum = (v: unknown): number => (typeof v === 'number' && Number.isFinite(v) ? v : 0);
const strN = (v: unknown): string | null => (typeof v === 'string' && v !== '' ? v : null);

const STATUSES: readonly JobRunStatus[] = ['running', 'ok', 'failed'];

export const toJobRun = (raw: unknown): JobRun => {
  const r = asObj(raw);
  return {
    id: strN(r.id) ?? '',
    jobName: strN(r.jobName) ?? '—',
    status: STATUSES.find((s) => s === r.status) ?? 'running',
    attempt: asNum(r.attempt) || 1,
    startedAt: strN(r.startedAt) ?? '',
    finishedAt: strN(r.finishedAt),
    durationMs: typeof r.durationMs === 'number' ? r.durationMs : null,
    detail: strN(r.detail),
  };
};

export const toTelemetryRow = (raw: unknown): TelemetryRow => {
  const r = asObj(raw);
  return {
    platform: strN(r.platform) ?? '—',
    provider: strN(r.provider) ?? '—',
    sent: asNum(r.sent),
    failed: asNum(r.failed),
    displayed: asNum(r.displayed),
    displayRate: asNum(r.displayRate),
  };
};
